import {Form} from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
    CloudUploadOutlined,
    DeleteFilled,
    DeleteOutlined,
    EditOutlined,
    InfoCircleOutlined,
    PictureOutlined,
    StarFilled,
    StopOutlined,
    ToTopOutlined,
    UploadOutlined
} from '@ant-design/icons';
import {Button as MuiButton, Stack, ThemeProvider} from "@mui/material";
import {
    Button,
    Col,
    DatePicker,
    Descriptions,
    Divider,
    Empty,
    Input,
    InputNumber,
    message,
    Modal,
    Row,
    Select,
    Table,
    Tag,
    Tooltip,
    Upload
} from 'antd';
import {aclPermissions, hasPermissions} from 'const/ACLPermissions';
import {delete_, get, get_pdf, get_response, post, post_response} from 'helper/request';
import _ from 'lodash';
import moment from "moment";
import querystring from "query-string";
import React, {Component, lazy, Suspense} from "react";
import cookie from "react-cookies";
import Carousel from "react-material-ui-carousel";
import 'react-quill/dist/quill.snow.css';
import {connect} from "react-redux";
import {getCaseIdPlaceholder, getCaseNamePlaceholder} from 'utils/org_utils';
import '../asset/style/add_case.css';
import '../asset/style/custom_antd_table_style.css';
import SlideSuggestions from "../component/case/add.slide.modal";
import {
    getChronologicalSorting,
    getLexicographicalSorting,
    getNumericalSorting,
    getReverseChronologicalSorting,
    getReverseLexicographicalSorting
} from "../component/case/case_utils";
import SpinLoader from '../component/common/SpinLoader';
import {
    decodeStringWithNewLine,
    getAssignCaseButtonComponent,
    getAssignCaseComponent,
    getDbEntryComponent,
    getDeleteComponent,
    getErrorComponent,
    getExportComponent,
    getLabelComponent,
    getLoadingComponent,
    getMorphleIDComponent,
    getPreviewComponent,
    getScreenshotCarousel,
    getStarredComponent,
    getTagsComponent,
    getTilingComponent,
    getUnauthorizedComponent
} from "../component/dashboard/slidelist_utils";
import {caseInfoApp} from "../component/gammaviewer/app_maker";
import FileScreenshotsList from "../component/gammaviewer/sidebarTop_apps/FileScreenshotsList";
import {deleteFile} from "../component/gammaviewer/utils/fileUtils";
import {convertMapStateToUrlParams} from "../component/gammaviewer/utils/linkMakerUtils";
import ShareModal from "../component/utils/shareModal";
import CaseSuggestions from "../component/viewer/viewer.case";
import SlideDetailsModal from '../component/viewer/viewer.slidedetails';
import {AuthHeader} from "../configs/auth.token";
import {CASE_STATUS} from "../const/cases_const";
import {caseUpdateAlert, loadCasePriorities, loadCaseStatus, loadUsers} from "../redux_actions/cases.action";
import {makeMenuVisible} from "../redux_actions/context.menu.action";
import {changePage} from '../redux_actions/search.action';
import {addCasesToShare} from "../redux_actions/shareManager.action";
import {deleteSlide, descUpdateAlert, slideUpdateAlert, startTiling, startUpload} from '../redux_actions/slides.action';
import {DEFAULT_DEBOUNCE, DEFAULT_RETRY} from '../utils/api.const';
import {FileType, openInNewTabType, responsiveLayers, slideStatusEnum} from '../utils/const';
import {SAVE_STATUS} from '../utils/enums';
import {urls} from '../utils/urls';
import {
    getFileExtension,
    getStateAwareUrl,
    isCloud,
    isNull,
    isSuperuser,
    isTrue,
    linkViewer,
    notNull,
    openEndPoint,
    slideStatusCategory
} from "../utils/utils";
import {defaultTheme} from "../component/gammaviewer/themes";
import {updateSort} from "../redux_actions/morpheus.setting.action";
import {error_manager} from "../helper/error_manager";

const ReactQuill = lazy(() => import('react-quill'));
const {Option} = Select;
const EditableContext = React.createContext();

const EditableFormRow = ({form, index, ...props}) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

class EditableCell extends Component {
    state = {
        editing: false,
    };

    toggleEdit = () => {
        const editing = !this.state.editing;
        this.setState({ editing }, () => {
            if (editing) {
                this.input.focus();
            }
        });
    };

    save = e => {
        const { record, handleSave } = this.props;
        this.form.validateFields((error, values) => {
            if (error && error[e.currentTarget.id]) {
                return;
            }
            this.toggleEdit();
            handleSave({ ...record, ...values });
        });
    };

    renderCell = form => {
        this.form = form;
        const {children, dataIndex, record} = this.props;
        const {editing} = this.state;
        return editing ? (
            <Form.Item style={{margin: 0}}>
                {form.getFieldDecorator(dataIndex, {
                    initialValue: record[dataIndex],
                })(<Input ref={node => (this.input = node)} onPressEnter={this.save} onBlur={this.save}/>)}
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{paddingRight: 24}}
                onClick={this.toggleEdit}
            >
                {children}
            </div>
        );
    };

    render() {
        const {
            editable,
            dataIndex,
            title,
            record,
            index,
            handleSave,
            children,
            ...restProps
        } = this.props;
        return (
            <td {...restProps}>
                {editable ? (
                    <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
                ) : (
                        children
                    )}
            </td>
        );
    }
}

const ButtonGroup = Button.Group;

class AllScansCaseView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFetchingCase: true,
            isFetchingFiles: true,
            isFetchingFilesSource: true,
            isFetchingSlides: true,
            isFetchingPendingScans: true,
            isFetchingComments: true,
            hasCaseThrownError: true,
            hasSlidesThrownError: true,
            hasCommentsThrownError: true,
            hasFilesThrownError: true,
            hasFilesSourceThrownError: true,
            hasPendingScansThrownError: true,
            selectedRowKeys: [],
            caseScans: {},
            caseScansArray: [],
            previewVisible: false,
            showFile: false,
            previewFile: '',
            caseFileList: [],
            caseFileListSource: [],
            currCase: [],
            pendingScans: [],
            comments: [],
            addSlideModalVisible: false,
            assignCaseModalVisible: false,
            currentHoverRowID: -1,
            screenshotVisible: false,
            screenshots: [],
            CAPContent: '',
            cap_map: [],

            rearchiveDays: null,
            archiveDays: null,
            selectedCAP: '',
            infoEditable: false,
            slideDetailsModelVisible: false,
            selectedSlide: {},
            patient_name :'',
            case_id : '',
            dob: new moment().format('YYYY-MM-DD'),
            age: 0,
            gender: 'M',
            priority: '',
            receiving_date: new moment().format('YYYY-MM-DD'),
            reporting_date: new moment().format('YYYY-MM-DD'),
            age_and_sex: '',
            consulting_doctor: '',
            can_edit: true,
            editing_user: '',
            carousel_index: 0,
            selected_users: [],

            save_status: SAVE_STATUS.NOT_STARTED
        }

        this.is_cloud = isCloud();
        this.is_superuser = isSuperuser()
        this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
            (document.documentElement.clientWidth < document.documentElement.clientHeight);
        this.iOS = cookie.loadAll().iOS === "true";
        this.debounce_timeout_id = '';
        this.error_timeout_id = '';
        this.debounce_controller = null;
        this.lockCapReport = this.props.abstract_configs['lockCapReport'];
        this.hasSlideViewPermission = hasPermissions([aclPermissions.view_slide_details]);
        this.viewCaseDetailPerm = hasPermissions([aclPermissions.view_case_details])
        this.deleteCasePerm = hasPermissions([aclPermissions.delete_case])
        this.editCaseDetailPerm = hasPermissions([aclPermissions.edit_case_details])
        this.assignCasePerm = hasPermissions([aclPermissions.assign_case])
        this.viewCapReportPerm = hasPermissions([aclPermissions.cap_report_app])

    }

    componentWillMount = () => {
        // this.getReArchiveDays();
        window.addEventListener("beforeunload", this.unload);
    }

    componentDidMount = () => {
        this.getCase();
        this.props.dispatch(loadUsers());
        this.props.dispatch(loadCaseStatus());
        this.props.dispatch(loadCasePriorities());

        let url = "/api/fetch_cap_map/";
        get_response(url)
            .then(response => {
                let cap_map = response.data;
                for (let i = 0; i < cap_map.length; i++) {
                    if (cap_map[i]["search_key"] === this.state.currCase.cap_report_type) {
                        cap_map[i]["search_key"] = this.state.currCase.cap_report
                    }
                }
                this.setState({
                    cap_map: cap_map
                });
            })
            .catch(err => {
                console.log(err);
            });
    }

    unload = () => {
        let url = "/api/open_cap_edit/"
        let case_id = this.state.currCase.case_id
        let data = {
            'case_id': case_id,
            'user_id': parseInt(cookie.load('user_id')),
        };
        post(url, querystring.stringify(data)).then();
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.state.save_status !== prevState.save_status && this.state.save_status === SAVE_STATUS.ERROR) {
            this.error_timeout_id = setInterval(() => {
                if (this.debounce_controller) return
                this.saveCAPReport()
            }, DEFAULT_RETRY)
        }

        if (this.state.save_status !== SAVE_STATUS.ERROR) {
            if (this.error_timeout_id) clearInterval(this.error_timeout_id)
            this.error_timeout_id = ''
        }

        if (prevState.CAPContent === this.state.CAPContent) return

        if (this.debounce_timeout_id) clearTimeout(this.debounce_timeout_id)
        this.debounce_timeout_id = setTimeout(this.saveCAPReport, DEFAULT_DEBOUNCE)
        this.setState({save_status: SAVE_STATUS.ON_GOING})
    }

    componentWillUnmount = () => {
        this.releaseCAPEditAccess()
    }

    getCAPReportEditStatus = () => {
        let url = "/api/get_cap_edit_status/"
        let case_id = this.state.currCase.case_id
        let data = {
            'case_id': case_id,
            'user_id': parseInt(cookie.load('user_id')),
        };
        post(url, querystring.stringify(data))
            .then(response_data => {
                    if(response_data["can_edit"] === 0){
                        this.setState({
                            can_edit: false,
                            editing_user: response_data["editing_user"]
                        })
                    }
                }
            );
    }

    releaseCAPEditAccess = () => {
        let url = "/api/open_cap_edit/"
        let case_id = this.state.currCase.case_id
        let data = {
            'case_id': case_id,
            'user_id': parseInt(cookie.load('user_id')),
        };
        post(url, querystring.stringify(data)).then();
    }

    getOverwriteAccess = () => {
        let url = "/api/overwrite_cap_edit/"
        let case_id = this.state.currCase.case_id
        let data = {
            'case_id': case_id,
            'user_id': parseInt(cookie.load('user_id')),
        };
        post(url, querystring.stringify(data))
            .then(() => {
                    this.getCAPReportEditStatus();
                    this.setState({
                        can_edit: true,
                    });
                }
            );
    }

    toggleInfoEdit = () => {
        let editable = this.state.infoEditable;
        this.setState({
            infoEditable: !editable,
        })
    }

    getCase = () => {
        this.setState({
            hasCaseThrownError: true,
            hasFilesThrownError: true,
            isFetchingCase: true,
            isFetchingFiles: true,
        });
        let url = `/api/case/${this.props.case}/?without_slides=true`;
        get(url, true)
            .then(data => {
                this.setState({
                    currCase: data,
                    isFetchingCase: false,
                    hasCaseThrownError: false,
                    patient_name: data.patient_name,
                    case_id: data['case_id'],
                    age: data.age_and_sex.split('/')[0],
                    gender: data.age_and_sex.split('/')[1],
                    priority: data['priority'],
                    receiving_date: data['receiving_date'],
                    reporting_date: data['reporting_date'],
                    age_and_sex: data['age_and_sex'],
                    consulting_doctor: data['consulting_doctor'],
                    registered_location: data['registered_location']
                });

                let caseFileList = data.files.filter(file => file.type !== FileType.SCREENSHOT)
                    .map(caseFile => ({
                        ...caseFile,
                        uid: caseFile.id,
                        name: caseFile.url_safe.split('/').pop(),
                        status: 'done',
                        url: caseFile.url_safe,
                    }));

                let screenshots = data.files.filter(file => file.type === FileType.SCREENSHOT);

                this.getCaseSlides(data);

                this.get_comments();
                this.getCAPReportEditStatus();
                this.setState({
                    caseFileList,
                    screenshots,
                    isFetchingFiles: false,
                    hasFilesThrownError: false,
                })

            })
            .catch(err => {
                if (err?.response?.status === 403) {
                    message.error("You don't have ACL permission to view this case")
                } else {
                    message.error("Cases could not be retrieved. Contact Admin.");
                }
                this.setState({
                    currCase: [],
                    caseFileList: [],
                    isFetchingCase: false,
                    isFetchingFiles: false,
                    isFetchingSlides: false,
                    isFetchingPendingScans: false,
                    isFetchingFilesSource: false,
                    hasSlidesThrownError: true,
                    hasPendingScansThrownError: true,
                    hasCaseThrownError: true,
                    hasFilesThrownError: true,
                    hasFilesSourceThrownError: true,
                });
                console.log(err.response);
            });
    }

    getCaseSlides = (currCase) => {
        this.setState({
            hasSlidesThrownError: true,
            isFetchingSlides: true,
            isFetchingPendingScans: true,
            hasPendingScansThrownError: true,
        });
        let url = `/api/nonpagslides/?case_id=` + currCase.id;
        get(url, true)
            .then(data => {
                let allSlidesUpdated = {};
                for (let i = 0; i < data.length; i++) {
                    allSlidesUpdated[i] = data[i];
                }

                this.setState({
                    caseScans: allSlidesUpdated,
                    caseScansArray: data,
                    selectedRowKeys: [],
                    previewVisible: false,
                    showFile: false,
                    previewFile: '',
                    isFetchingSlides: false,
                    hasSlidesThrownError: false,
                })
            })
            .catch(err => {
                message.error("Slides could not be retrieved. Contact Admin.");
                console.log(err);
                this.setState({
                    caseScans: {},
                    caseScansArray: [],
                    selectedRowKeys: [],
                    previewVisible: false,
                    showFile: false,
                    previewFile: '',
                    isFetchingSlides: false,
                    isFetchingPendingScans: false,
                })
            });
    }

    get_comments = () => {
        let url = '/api/microscopy_observations/?case_id=' + this.state.currCase.id;
        get_response(url)
            .then(response => {
                let data = response.data;
                for (let i = 0; i < data.length; i++) {
                    data[i].key = data[i].id;
                    let modifiedValue = decodeStringWithNewLine(data[i].observation);
                    data[i].observation_original = data[i].observation;
                    data[i].observation = modifiedValue;
                }
                this.setState({
                    comments: data,
                    isFetchingComments: false,
                    hasCommentsThrownError: false,
                });
            })
            .catch(err => {
                console.log("Failed request", err);
                this.setState({
                    comments: [],
                    isFetchingComments: false,
                });
            });
    }

    handleUpload = (morphle_id, id, uploadDebug, uploadDebugOnly) => {
        this.props.dispatch(startUpload(morphle_id, id, uploadDebug, uploadDebugOnly));
    }

    handleDelete = (slide, button) => {
        if (button) {
            let newCaseScans = {};
            let newCaseScansArray = [];
            for (let i = 0; i < this.state.caseScansArray.length; i++) {
                if (slide.id !== this.state.caseScansArray[i].id) {
                    newCaseScans[i] = this.state.caseScans[i];
                    newCaseScansArray.push(this.state.caseScansArray[i]);
                }
            }
            this.setState({
                caseScans: newCaseScans,
                caseScansArray: newCaseScansArray
            });
        }
        this.props.dispatch(deleteSlide(slide, this.props.urlState));
    }

    starSelectedRows = () => {
        this.state.selectedRowKeys.forEach(value => {
            this.handleStarButton(this.state.caseScans[value], true);
        });
    }

    uploadSelectedRows = () => {
        this.state.selectedRowKeys.forEach(value => {
            const slide = this.state.caseScans[value];
            this.props.dispatch(startUpload(slide.morphle_id, slide.id, false, false));
        });
    }

    tileSelectedRows = () => {
        this.state.selectedRowKeys.forEach(value => {
            const slide = this.state.caseScans[value];
            this.props.dispatch(startTiling(this.state.caseScans[value].morphle_id, slide.id));
        });
    }

    unstarSelectedRows = () => {
        this.state.selectedRowKeys.forEach(value => {
            this.handleStarButton(this.state.caseScans[value], false);
        });
    }

    deleteSelectedRows = () => {
        this.state.selectedRowKeys.forEach(value => {
            if (this.state.caseScans[value] === undefined) return;
            this.handleDelete(this.state.caseScans[value], false);
        });
        let newCaseScans = {};
        let newCaseScansArray = [];
        for (let i = 0; i < this.state.caseScansArray.length; i++) {
            if (!this.state.selectedRowKeys.includes(i)) {
                newCaseScans[i] = this.state.caseScans[i];
                newCaseScansArray.push(this.state.caseScansArray[i]);
            }
        }
        this.setState({
            caseScans: newCaseScans,
            caseScansArray: newCaseScansArray
        });
        message.loading("Scheduling slides for Deletion");
    }

    handleStarButton = (slide, input) => {
        let newCaseScans = this.state.caseScans;
        let newCaseScansArray = this.state.caseScansArray;
        let index = newCaseScansArray.findIndex((item) => slide.id === item.id);
        newCaseScans[index].starred = input;
        newCaseScansArray[index].starred = input;
        this.setState({
            caseScans: newCaseScans,
            caseScansArray: newCaseScansArray
        });
        let val = {
            morphle_id: slide.morphle_id,
            path: slide.path,
            date: slide.date,
            specimen_type: slide.specimen_type,
            name: slide.name,
            starred: input,
            displayOrder: slide.displayOrder
        };
        this.props.dispatch(slideUpdateAlert(slide.id, val));
    };

    handleNameChange = (slide, newName) => {
        let newCaseScans = this.state.caseScans;
        let newCaseScansArray = this.state.caseScansArray;
        let index = newCaseScansArray.findIndex((item) => slide.id === item.id);
        newCaseScans[index].name = newName;
        newCaseScansArray[index].name = newName;
        this.setState({
            caseScans: newCaseScans,
            caseScansArray: newCaseScansArray
        });
        let val = {
            morphle_id: slide.morphle_id,
            path: slide.path,
            date: slide.date,
            specimen_type: slide.specimen_type,
            name: newName,
            starred: slide.starred,
            displayOrder: slide.displayOrder
        };
        this.props.dispatch(slideUpdateAlert(slide.id, val));
    };

    openDeleteModal = () => {

        var deletedIDs = "";

        this.state.selectedRowKeys.forEach((value, index) => {
            if (this.state.caseScans[value] !== undefined && index !== this.state.selectedRowKeys.length - 1)
                deletedIDs += (this.state.caseScans[value] || {}).name + ", ";
        });

        deletedIDs += this.state.caseScans[this.state.selectedRowKeys[this.state.selectedRowKeys.length - 1]].name;

        const deleteRowsHandle = this.deleteSelectedRows;

        Modal.confirm({
            title: 'Following scans will be deleted. Confirm?',
            icon: <InfoCircleOutlined></InfoCircleOutlined>,
            content: (<Row>{deletedIDs}</Row>),
            onOk() { deleteRowsHandle() },
            onCancel() { }
        });
    }

    removeFromCase = () => {
        let slides = []
        this.state.selectedRowKeys.forEach(value => {
            if (this.state.caseScans[value] !== undefined)
                slides.push(this.state.caseScans[value].id)
        });
        let url = `/api/remove_slides_from_case/?slides=${slides}`
        get_response(url, true)
            .then(response => {
                if (response.status === 200) {
                    let caseScans = this.state.caseScansArray;
                    slides.forEach(slideValue => {
                        caseScans.forEach((caseValue, caseIndex) => {
                            if (slideValue === caseValue.id) {
                                caseScans.splice(caseIndex, 1)
                            }
                        })
                    })
                    this.setState({
                        caseScansArray: caseScans,
                        selectedRowKeys: [],
                    })
                    message.success("Successfully removed slides");
                } else {
                    message.error("Error removing slides. Please contact Admin");
                }
            })
            .catch(() => {
                message.error("Error removing slides. Please contact Admin")
                console.log("Error removing slide. Please contact Admin");
            })
    }
    getRowActionsIfAtleastOneRowSelected = () => {
        if (this.state.caseScansArray.length > 0) {
            return this.state.selectedRowKeys.length > 0 ?
                <ButtonGroup key={1}>
                    <Button onClick={() => { this.setState({ selectedRowKeys: Object.keys(this.state.caseScans).map((value) => parseInt(value)) }) }}>
                        Select All Scans
                    </Button>
                    <Button key={0} onClick={() => { this.setState({ selectedRowKeys: [] }) }}>
                        Cancel Selection
                        </Button>
                    {this.is_superuser ?
                        <Button key={1} onClick={this.tileSelectedRows}>
                            Start Tiling
                        </Button> : undefined}
                    {!this.is_cloud && hasPermissions([aclPermissions.upload_slide]) ?
                        <Button key={-1} onClick={this.uploadSelectedRows}>
                            Upload
                            <CloudUploadOutlined style={{ fontSize: "13px" }} />
                        </Button> : undefined}
                    <Button key={2} onClick={this.starSelectedRows}>
                        Star
                            <StarFilled style={{ color: "#f5667b", fontSize: "13px" }} />
                    </Button>
                    <Button key={3} onClick={this.unstarSelectedRows}>
                        Unstar
                            <StarFilled style={{ fontSize: "13px" }} />
                    </Button>
                    <Button key={4} onClick={this.openDeleteModal} disabled={!hasPermissions([aclPermissions.delete_slide])}>
                        Delete
                            <DeleteFilled style={{ fontSize: "13px" }} />
                    </Button>
                    <Button key={5} onClick={this.removeFromCase} disabled={!hasPermissions([aclPermissions.update_slides_in_case])}>
                        Remove From {getCaseNamePlaceholder()}
                        <StopOutlined />
                    </Button>
                </ButtonGroup> :
                <>
                <Col span={16}>
                    <Button onClick={() => { this.setState({ selectedRowKeys: Object.keys(this.state.caseScans).map((value) => parseInt(value)) }) }}>
                        Select All Scans
                    </Button>
                </Col>
                <Col span={2}>
                    <Select
                        value={this.props.sorting}
                        placeholder="Sort List"
                        onChange={this.handleSortingMethodChange}
                        style={{width:230}}
                    >
                        <Option value="name">
                            {" "}
                            A-Z
                        </Option>
                        <Option value="-name">
                            {" "}
                            Z-A
                        </Option>
                        <Option value="date_time">
                            Oldest First
                        </Option>
                        <Option value="-date_time">
                            Recent First
                        </Option>
                        <Option value="number">
                            By Slide Number
                        </Option>
                    </Select>
                </Col>
              </>
        } else {
            return null;
        }

    }

    getRowActions = () => {
        return <Row>
            <Col>
                <span key={0} style={{ marginRight: "10px" }}>
                    {this.state.selectedRowKeys.length > 0 ? "What do you want to do with the selected scans ? " : ""}
                </span>
	            {this.getRowActionsIfAtleastOneRowSelected()}
            </Col>
        </Row>
    }

	updatePage = (pageNumber) => {
		openEndPoint('/dashboard?page=' + pageNumber, false, true);
		this.props.dispatch(changePage(pageNumber, this.props.urlState));
	}

	handlePreview = file => {
        let file_list = this.state.caseFileList
        for (let i = 0; i < file_list.length; i++) {
            if (file_list[i]['uid'] === file.uid) {
                this.setState({
                    carousel_index: i,
                })
                break;
            }
        }
        let fileExtension = getFileExtension(file.name);
        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
            this.setState({
                showFile: true,
            });
        } else {
            this.setState({
                showFile: false,
            });
        }
        this.setState({
            previewFile: file.url || file.preview,
            previewVisible: true,
        });
    };

    handleAssignCase = (slide) => {
        this.setState({
            selectedSlide: slide,
            assignCaseModalVisible: true,
        });
    }

    handleCancel = () => this.setState({ previewVisible: false });

    handleScreenshotPreview = (slide) => {
        this.setState({
            screenshotVisible: true,
            screenshots: slide.screenshots
        });
    }

    handleScreenshotCancel = () => {
        this.setState({
            screenshotVisible: false
        })
    }
    handleChangeCaseFile = ({fileList}) => {
        let caseFileList = _.map(fileList, (caseFile) => {
            if (caseFile.response) {
                return {
                    ...caseFile.response,
                    uid: caseFile.response.id,
                    name: caseFile.response.file.split('/').pop(),
                    status: 'done',
                    url: caseFile.response.file,
                };
            } else {
                return caseFile;
            }
        });
        this.setState({
            caseFileList: caseFileList
        });
    }

    handleDeleteScreenshot = (screenshot) => deleteFile(screenshot).then(() =>
        this.setState({
            screenshots: this.state.screenshots.filter((s) => s.id !== screenshot.id)
        }));

    handleChangeUploadTRF = (info) => {
        let trfFile = [...info.fileList].slice(-1)[0];
        this.setState({trfFile});
        if (info.file.status === 'done') {
            let url = `/api/case/` + this.props.case + `/`;
            get(url, true)
                .then(data => {
                    this.setState({
					    currCase: data,
					    isFetchingCase: false,
					    hasCaseThrownError: false,
				    });
			    })
	    }
    }

	handleRemoveTrfFile = () => {
		delete_(`/api/delete_trf/${this.props.case}/`).then(() => get(`/api/case/${this.props.case}/`,true)
			.then(data => {
				this.setState({
					currCase: data,
					isFetchingCase: false,
					hasCaseThrownError: false,
				});
			}))
			.catch(() => {
				message.error('Failed to delete file');
			});
	}

	onChangeCAPContent = (value) => {
		this.setState({
			CAPContent: value
		})
	}

    beforeUpload(file) {
        if (file.type === "application/pdf" || file.type.substring(0, 5) === "image") {
            return true;
        } else {
            message.error('Invalid file type selected!!');
            return false;
        }
    }

	handleSortingMethodChange = (value) => {
		this.props.dispatch(updateSort({slide_in_case_order_by: value}))
	}

	getTableSource = (allSlides, getIntegersfromString, sortingMethod) => {
		let allSlidesList = []
		let sortedAllSlides = []

		switch (sortingMethod) {
			case 'name':
				sortedAllSlides = getLexicographicalSorting(allSlides)
				break;
			case '-name':
				sortedAllSlides = getReverseLexicographicalSorting(allSlides)
				break;
			case 'number':
				sortedAllSlides = getNumericalSorting(allSlides, getIntegersfromString)
                break;
            case 'date_time':
                sortedAllSlides = getChronologicalSorting(allSlides)
                break;
            case '-date_time':
                sortedAllSlides = getReverseChronologicalSorting(allSlides)
                break;
            default:
                break;
        }

        sortedAllSlides.forEach(key => {
            let slide = allSlides[key];
            if (slide.slide_details === undefined || slide.slide_details === "") {
                slide.slide_details = "-";
            }
            if (!slide.isDeleted) {
                allSlidesList.push({
                    key: parseInt(key),
                    id: slide.id,
                    slide_details: slide.slide_details,
                    unread: slide.unread,
                    type: openInNewTabType.SLIDE,
                    slideCard: this.getSlideCardFlex(slide),
                })
            }
        });
        return allSlidesList;
    }

    handleRetrieveSlide = (slide) => {
        let url = `/api/retrieve_from_glacier/?slide_id=${slide.id}`
        get(url, true)
            .then(() => {
                let val = {
                    morphle_id: slide.morphle_id,
                    path: slide.path,
                    date: slide.date,
                    specimen_type: slide.specimen_type,
                    name: slide.name,
                    starred: slide.starred,
                    displayOrder: slide.displayOrder,
                    availability_status: 2,
                };
                this.props.dispatch(slideUpdateAlert(slide.id, val));
            }).catch(err => {
            console.log(err)
        })
    }

    getSlideInfoCardDetails = (slide) => {
        return <>
            <div className={'preserve-white-space'}>
                <div>
                    {slide.unread ?
                        <b> {isNull(slide.section_id)? slide.name : slide.name + "," + slide.section_id}</b> :
                        <span style={{ fontWeight: 400 }}> {isNull(slide.section_id)? slide.name : slide.name + "," + slide.section_id}</span>
                    }
                </div>
                {slide.case_id.length > 0 ?
                    <div style={{ marginTop: 5, fontSize: 12 }}>
                        <span>{`${getCaseIdPlaceholder()}: ${slide.case_id}`}</span>
                    </div> : null
                }
            </div>
            <div style={{ marginTop: 10 }}>
                {getTagsComponent(slide, this.props.dispatch, this.props.urlState, this.isMobile)}
            </div>
        </>
    }

    getGroupActionables = (slide) => {
        const betweenL4AndL5 = document.documentElement.clientWidth > responsiveLayers.LEVEL_5 &&
            document.documentElement.clientWidth <= responsiveLayers.LEVEL_4;
        let marginRight = 8;
        if (betweenL4AndL5) {
            marginRight = 7;
        }
        return <div className={"row-flex"}>
            <div className='star-forTour' style={{marginRight: marginRight}}>
                {getStarredComponent(slide, this.handleStarButton)}
            </div>
            {!isCloud() && (slideStatusCategory(slide.status) === slideStatusEnum.VIEWER_READY ?
                <>
                    {this.is_superuser ? <div style={{marginRight: marginRight}}>
                        {getTilingComponent(slide, this.props.dispatch)}
                    </div> : null}
                    <div className='export-forTour' style={{marginRight: marginRight}}>
                        {getExportComponent(slide, this.props.dispatch)}
                    </div>
                    <div style={{marginRight: marginRight}}>
                        {getAssignCaseComponent(slide, this.handleAssignCase)}
                    </div>
                </> : null)
            }
        </div>
    }

    getActionables = (slide, isBetweenL6AndMobile) => {
        return <div className={"row-flex"} style={{marginTop: "10px", marginLeft: isBetweenL6AndMobile ? "10px":0}}>
            {this.is_superuser ?
                <div style={{marginRight: "10px"}}>
                    {getDbEntryComponent(slide)}
                </div> : null
            }
            {this.is_superuser ?
                <div style={{marginRight: "10px"}}>
                    {getMorphleIDComponent(slide)}
                </div> : null
            }
            <div style={{marginRight: "10px"}}>
                {getDeleteComponent(slide, this.handleDelete)}
            </div>
        </div>
    }

    getSlideInfo = (slide) => {
        let marginRight = 10;
        if (document.documentElement.clientWidth > responsiveLayers.LEVEL_3) {
            marginRight = 25;
        }
        let aboveL4 = document.documentElement.clientWidth > responsiveLayers.LEVEL_4;
        let aboveL6 = document.documentElement.clientWidth > responsiveLayers.LEVEL_6;
        return <div style={{marginTop: this.hasSlideViewPermission ? 35 : "auto", display: "flex", flexDirection: "row"}}>
            <div className={"column-flex"} style={{justifyContent: "flex-start", alignItems: "flex-start", marginRight: marginRight, width: "74px"}}>
                {slide.unread ?
                    <b>{slide.date}</b> :
                    <span>{slide.date}</span>
                }
            </div>
            {this.hasSlideViewPermission && aboveL6 ?
                <div style={{width: "80px"}}>
                    <div>{slide.unread ? slide.specimen_type === "AUTO" ? <b>HNE</b> : <b>{slide.specimen_type}</b> :
                        slide.specimen_type === "AUTO" ? "HNE" : slide.specimen_type }</div>
                    <div>{slide.unread ?
                        <b>{slide.scan_speed}</b> :
                        <span>{slide.scan_speed}</span>}
                    </div>
                    {hasPermissions([aclPermissions.devices_menu]) && !this.state.showAnalysisPanel
                    && document.documentElement.clientWidth > responsiveLayers.LEVEL_2 ?
                        slide.unread ? <b>{slide.device_name}</b> : slide.device_name :null
                    }
                </div> : null
            }
            {this.hasSlideViewPermission && aboveL4 ?
                <div style={{width: "80px"}}>
                    {slide.unread ?
                        <b>{slide.scan_time}</b> :
                        <span>{slide.scan_time}</span>
                    }
                </div> :
                null
            }
        </div>
    }


    getSlideCard = (slide) => {
        return <div>
            <Row>
                <Col span={5} style={{ marginTop: 40 }}>
                    <Row>
                        <Col span={4}>
                            {getStarredComponent(slide, this.handleStarButton)}
                        </Col>
                        {/*TODO: @Spandan glacier component was commented out as it wasnt needed at the time*/}
                        {/*<Col span={8}>*/}
                        {/*    /!*{getUploadComponent(slide, this.handleUpload)}*!/*/}
                        {/*    {getGlacierComponent(slide, this.handleRetrieveSlide, this.state.archiveDays, this.state.rearchiveDays)}*/}
                        {/*</Col>*/}
                        {this.is_superuser ?
                            <Col span={4}>
                                {getTilingComponent(slide, this.props.dispatch)}
                            </Col> :
                            null
                        }
                        <Col span={4}>
                            {getExportComponent(slide, this.props.dispatch)}
                        </Col>
                        <Col span={4}>
                            {getAssignCaseComponent(slide, this.handleAssignCase)}
                        </Col>
                    </Row>
                </Col>
                <Col span={6} style={{ marginTop: 10 }}>
                    <Row>
                        {slide.unread ?
                            <b> {isNull(slide.section_id)? slide.name : slide.name + "," + slide.section_id}</b> :
                            <span style={{ fontWeight: 400 }}> {isNull(slide.section_id)? slide.name : slide.name + "," + slide.section_id}</span>
                        }
                    </Row>
                    {slide.case_id.length > 0 ?
                        <Row style={{ marginTop: 5, fontSize: 13 }}>
                            <span>{"Case: " + slide.case_id}</span>
                        </Row> :
                        this.state.currentHoverRowID === slide.id ?
                            <Row style={{ marginTop: 5 }}>
                                {getAssignCaseButtonComponent(slide, this.handleAssignCase)}
                            </Row> :
                            null
                    }
                    <Row style={{ marginTop: 10, maxWidth:  300}}>
                        {getTagsComponent(slide, this.props.dispatch, this.props.urlState)}
                    </Row>
                </Col>
                <Col span={4}>
                    {getPreviewComponent(slide, this.is_cloud, this.isMobile)}
                </Col>
                <Col span={2}>
                    {getLabelComponent(slide, this.is_cloud, this.isMobile, true)}
                </Col>
                <Col span={slide.screenshots.length === 0 ? 7 : 6}>
                    <Row style={{ marginTop: 10 }}>
                        {this.is_superuser ?
                            <Col span={4}>
                                {getDbEntryComponent(slide)}
                            </Col> :
                            null
                        }
                        {this.is_superuser ?
                            <Col span={4}>
                                {getMorphleIDComponent(slide)}
                            </Col> :
                            null
                        }
                        {hasPermissions([aclPermissions.delete_slide]) ?
                            <Col span={4}>
                                {getDeleteComponent(slide, this.handleDelete)}
                            </Col> :
                            null
                        }
                    </Row>
                    <Row>
                        <Col offset={this.is_superuser ? 0 : this.hasSlideViewPermission ? 3 : 18} span={6}>
                            {slide.unread ?
                                <b>{slide.date}</b> :
                                <span>{slide.date}</span>
                            }
                        </Col>
                        {this.hasSlideViewPermission ?
                            <Col span={4}>
                                <div>{slide.unread ? slide.specimen_type === "AUTO" ? <b>HNE</b> : <b>{slide.specimen_type}</b> :
                                    slide.specimen_type === "AUTO" ? "HNE" : slide.specimen_type }</div>
                                <div>{slide.unread ?
                                    <b>{slide.scan_speed}</b> :
                                    <span>{slide.scan_speed}</span>}
                                </div>
                                {hasPermissions([aclPermissions.devices_menu]) && !this.state.showAnalysisPanel
                                && document.documentElement.clientWidth > responsiveLayers.LEVEL_2 ?
                                    slide.unread ? <b>{slide.device_name}</b> : slide.device_name :null
                                }
                            </Col> : null
                        }
                        {this.hasSlideViewPermission ?
                            <Col span={6}>
                                {slide.unread ?
                                    <b>{slide.scan_time}</b> :
                                    <span>{slide.scan_time}</span>
                                }
                            </Col> :
                            null
                        }
                    </Row>
                </Col>
                { true ? null :
                <Col span={1}>
                    <PictureOutlined onClick={(e) => {e.stopPropagation(); this.handleScreenshotPreview(slide)}} className="icon-hover"
                        style={{marginTop: '25px', fontSize: '23px', marginLeft: '10px', padding: '10px'}} />
                </Col>}
            </Row>
        </div>
    }

    getSlideCardFlex = (slide) => {

        const betweenL4AndL5 = document.documentElement.clientWidth > responsiveLayers.LEVEL_5 &&
            document.documentElement.clientWidth <= responsiveLayers.LEVEL_4;
        const belowL2 = document.documentElement.clientWidth <= responsiveLayers.LEVEL_2;
        const belowL3 = document.documentElement.clientWidth <= responsiveLayers.LEVEL_3;
        const aboveL5= document.documentElement.clientWidth > responsiveLayers.LEVEL_5;
        const betweenL6AndMobile = document.documentElement.clientWidth <= responsiveLayers.LEVEL_6 &&
            document.documentElement.clientWidth > responsiveLayers.MOBILE_WIDTH_LEVEL;

        let aboveL6 = document.documentElement.clientWidth > responsiveLayers.LEVEL_6;
        return (
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}} className="slide-entry-forTour">
                { aboveL5 ?  <div className={"row-flex"} style={{width: betweenL4AndL5 ? "25%": belowL3 ? "20%" : "17%", flexShrink: 0}}>
                    <div className={"group-actionable-container"} style={{width: belowL2 ? "100%" : "75%"}}>
                        {this.getGroupActionables(slide)}
                    </div>
                </div> : null }
                <div style={{width: betweenL6AndMobile ? "32%" : betweenL4AndL5 ? "22%" : "20%", maxWidth: "280px"}}>
                    {this.getSlideInfoCardDetails(slide)}
                </div>
                <div
                    style={{display: "flex", alignItems: "center", overflowX: "hidden", justifyContent: "space-between", width: this.isMobile ? "auto" : "280px"}}>
                    <div style={{marginRight: betweenL4AndL5 ? 0 : "10px"}}>
                        {getPreviewComponent(slide, this.is_cloud, this.isMobile)}
                    </div>
                    <div>
                        {getLabelComponent(slide, this.is_cloud, this.isMobile, true)}
                    </div>
                </div>
                <div>
                    {aboveL6 ? this.getActionables(slide, betweenL6AndMobile) : null}
                    {this.getSlideInfo(slide)}
                </div>
            </div>
        )
    }


    handleSave = row => {
        let newCaseScans = this.state.caseScans;
        let newCaseScansArray = this.state.caseScansArray;
        let index = newCaseScansArray.findIndex((item) => row.id === item.id);
        newCaseScans[index].slide_details = row.slide_details;
        newCaseScansArray[index].slide_details = row.slide_details;
        this.setState({
            caseScans: newCaseScans,
            caseScansArray: newCaseScansArray
        });
        this.sendDescToCloud(row.id, row.slide_details, newCaseScansArray[index].displayOrder);
    };

    sendDescToCloud = (slideId, desc, displayOrder) => {
        this.props.dispatch(descUpdateAlert(slideId, desc, displayOrder));
    };

    toAllSlidesPage = () => {
        this.setState({
            addSlideModalVisible: true,
        });
    }

    closeModal = () => {
        this.getCase();
        this.setState({
            addSlideModalVisible: false,
            slideDetailsModelVisible: false,
            assignCaseModalVisible: false
        });
    }

    generateReport = () => {
        let url = getStateAwareUrl(`/api/get_pdf/?case_id=${this.state.currCase.case_id}&user_id=${cookie.loadAll().user_id}&lockCapReport=${this.lockCapReport}`);
        get_pdf(url)
    }

    handleCaseReport = (changeArchiveStatus, newArchiveStatus, case_status) => {
        if (!notNull(case_status)) {
            return
        }
        let val;
        if (changeArchiveStatus) {
            val = {
                case_id: this.state.currCase.case_id,
                displayOrder: this.state.currCase.displayOrder,
                change_slide_archive_status: changeArchiveStatus,
                archive_status: newArchiveStatus,
                case_status_id: case_status,
            };
        } else {
            val = {
                case_id: this.state.currCase.case_id,
                displayOrder: this.state.currCase.displayOrder,
                case_status_id: case_status,
            };
        }
        this.props.dispatch(caseUpdateAlert(this.state.currCase.id, val, [this.state.currCase.id], false));
        let updatedCase = this.state.currCase
        updatedCase.case_status = this.props.allCaseStatus[case_status]?.status
        if (changeArchiveStatus) {
            updatedCase.archive_status = newArchiveStatus
        }
        this.setState({currCase: updatedCase})
    };

    handleCAPTemplateChange = (value) => {
        this.setState({
            selectedCAP: value
        })
        let template = ""
        let cap_map = this.state.cap_map
        // // console.log('capmap', this.state.currCase, this.state.cap_map)
        for (let i = 0; i < cap_map.length; i++) {
            if (cap_map[i]["search_key"] === value) {
                console.log(this.state.currCase["cap_report_type"])
                if (cap_map[i]["search_key"] === this.state.currCase.cap_report_type) {
                    template = this.state.currCase.cap_report
                }
                else {
                    template = this.state.cap_map[i]["template"]
                    break;
                }
            }
        }
        this.setState({
            CAPContent: template
        })
    }

    saveCAPReport = () => {
        const report = this.state.CAPContent
        const report_type = this.state.selectedCAP || "No Template"
        const case_id = this.state.currCase.case_id
        const data = {
            report,
            case_id,
            report_type,
            user_id: parseInt(cookie.load('user_id'))
        }

        if (this.debounce_controller) this.debounce_controller.abort()
        this.debounce_controller = new AbortController()

        post_response(
            urls.SAVE_CAP_REPORT,
            querystring.stringify(data), {
                signal: this.debounce_controller?.signal
            })
            .then(response => {
                    if (parseInt(response.data['can_edit']) !== 0) return
                    message.info(`Couldn't edit while ${response.data['editing_user']} is editing`)

                    this.setState({
                        can_edit: false,
                        editing_user: response.data['editing_user']
                    })
                }
            )
            .then(() => this.setState({save_status: SAVE_STATUS.COMPLETED}))
            .catch((e) => {
                this.debounce_controller = null
                if (this.debounce_timeout_id) clearTimeout(this.debounce_timeout_id)
                this.debounce_timeout_id = ''
                this.setState({save_status: SAVE_STATUS.ERROR})
            })
    }

    updateCase = () => {
        let val = {
            id: this.state.currCase.id,
            case_id: this.state.case_id.toUpperCase(),
            patient_name: this.state.patient_name,
            age: this.state.age,
            gender: this.state.gender,
            priority: this.state.priority,
            receiving_date: this.state.receiving_date,
            reporting_date: this.state.reporting_date,
            consulting_doctor: this.state.consulting_doctor,
            registered_location: this.state.registered_location,
        }
        let url = '/api/update_case/'
        post_response(url, querystring.stringify(val))
            .then(() => {
                message.success("Case Updated Successfully")
                this.getCase();
            })
            .catch((err) => {
                const msg = notNull(err?.response?.data) ? err.response.data : "Failed to Update Case. Contact Morphle Support"
                error_manager(msg, err);
                this.getCase();
            })
        this.toggleInfoEdit();
    }

	deleteCase = () =>
		delete_(`/api/case/${this.state.currCase.id}/`)
			.then(() => openEndPoint("/cases"))
			.catch(err => {
				message.error("Failed to Delete Case. Contact Admin");
				console.log(err);
			});

    calcAge = (dateString)=>{
        const birthday = +new Date(dateString);
        return ~~((Date.now() - birthday) / (31557600000));
    }

    onChangeDOB = (date, dateString) => {
        let age = this.calcAge(dateString)
        this.setState({
            dob: dateString,
            age: age,
        });
    }

    onChangeAge = (value) => {
        if(!Number.isInteger(value)){
            message.info("Only number accepted as DOB")
            return;
        }
        this.setState({
            age: value,
            dob: '',
        })
    }

	onChangeGender = (value) => {
		console.log("change", value)
		this.setState({
			gender: value,
		});
	}

	onChangePriority = (value) => {
		this.setState({
            priority: value,
        })
    }

    onChangeReceivingDate = (date, dateString) => {
        this.setState({
            receiving_date: dateString
        });
    }

    onChangeReportingDate = (date, dateString) => {
        this.setState({
            reporting_date: dateString
        });
    }

    handleRegisteredLocationChange = (value) => {
        this.setState({
            registered_location: value,
        });
    }

    onChangeCaseId = (event) => {
        this.setState({
            case_id: event.target.value,
        })
    }

    onChangePatientName = (event) => {
        this.setState({
            patient_name : event.target.value,
        })
    }

    onChangeConsultingDoctor = (event) => {
        this.setState({
            consulting_doctor: event.target.value,
        })
    }

    getRegisteredLocationOptions = () => {
        return [
            <Option key={1} value={"Vasai (Main Centre)"}>Vasai (Main Centre)</Option>
        ];
    }

    getAssignedNamesComponent = (caseInfo) => {
        let all_users =  caseInfo.assigned_users.map(user => {
            const full_name = user.first_name + ' ' + user.last_name;
            const isLongUserName = full_name.length > 20;
            let color = 'blue';
            const userNameElem = (
                <Tag key={user.id} color={color} onClick={(event) => event.stopPropagation()}>
                    {isLongUserName ? `${full_name.slice(0, 20)}...` : full_name}
                </Tag>
            );
            return isLongUserName ?
                <Tooltip title={full_name} key={user.id}>{userNameElem}</Tooltip> : userNameElem
        });
        all_users.unshift(<Button style={{marginRight: '10px'}}
                                  disabled={!this.assignCasePerm || (this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED)}
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      this.caseRefreshProps = [caseInfo];
                                      this.props.dispatch(addCasesToShare(caseInfo.id))
                                  }}>
                Open Assignment Panel
            </Button>)
        return all_users;
    }

    archivalLogicHandler = () => {
        if (this.props.allCaseStatus && typeof this.props.allCaseStatus === 'object') {
            const statuses = Object.values(this.props.allCaseStatus)
            if (statuses.length > 1) {
                const last_status = statuses[statuses.length - 1]
                const first_status = statuses[0]
                if (this.state.currCase?.case_status === last_status.status) {
                    return [true, first_status.id]
                } else {
                    return [false, last_status.id]
                }
            }
        }
        return [false, null]
    }

    render() {

        if (!this.viewCaseDetailPerm) return getUnauthorizedComponent()

        let assigned_users_component=null
        if(this.state.currCase !== [] && this.state.currCase.assigned_users !== undefined){
            assigned_users_component = this.getAssignedNamesComponent(this.state.currCase)
        }

        if (this.state.selectedCAP === '' && !(this.state.currCase instanceof Array)) {
            // console.log('x', (this.state.currCase))

            if (this.state.currCase.cap_report_type !== '') {
                this.setState({
                    selectedCAP: this.state.currCase.cap_report_type,
                    CAPContent: this.state.currCase.cap_report
                })
            }
        }
        let cap_report_name_options = (this.state.cap_map !== undefined || this.state.cap_map !== []) ?
            this.state.cap_map.map(item => (
                <Option key={item.search_key} value={item.search_key}>
                    {item.display_name}
                </Option>
            )) : undefined;

        let overallFetchingState = (this.state.isFetchingCase && this.state.isFetchingComments && this.state.isFetchingFiles
            && this.state.isFetchingPendingScans && this.state.isFetchingSlides);

        let overallErrorState = (this.state.hasCaseThrownError && this.state.hasCommentsThrownError && this.state.hasFilesThrownError
            && this.state.hasPendingScansThrownError && this.state.hasSlidesThrownError);

        let tableSource =
            this.getTableSource(this.state.caseScansArray, this.getIntegersfromString, this.props.sorting);

        let finalColumns = [{
            dataIndex: 'slideCard',
            key: 'slideCard',
        }];

        const rowSelection = {
            onChange: selectedRowKeys => {
                this.setState({
                    selectedRowKeys: selectedRowKeys
                })
            },
            selectedRowKeys: this.state.selectedRowKeys
        };

        const onRow = record => {
            return {
                onContextMenu: (event) => {
                    event.preventDefault();
                    this.props.dispatch(makeMenuVisible({
                        visible: true,
                        x: event.clientX,
                        y: event.clientY,
                        record: record,
                        height: this.props.height
                    }));
                },
                onMouseEnter: (event) => {
                    event.preventDefault();
                    this.setState({
                        currentHoverRowID: record.id,
                    });
                },
                onMouseLeave: (event) => {
                    event.preventDefault();
                    this.setState({
                        currentHoverRowID: -1,
                    });
                }
            };
        }

        let rowActions = this.isMobile ? undefined :
            [
                <Divider key={3} />,
                <Row key={0} className="row-actions">
                    {this.getRowActions()}
                </Row>
            ];

        console.log("sorted: ", this.isMobile)

        const components = {
            body: {
                row: EditableFormRow,
                cell: EditableCell,
            },
        };



        finalColumns = finalColumns.map(col => {
            if (col.dataIndex === 'tagsComponent') {
                return col;
            } else {
                return {
                    ...col,
                    onCell: record => ({
                        onClick: (event) => {
                            const slide_record = this.state.caseScans[Object.keys(this.state.caseScans).filter((value) => {return this.state.caseScans[value].id === record.id})];
                            linkViewer(slide_record, `??topApp=${caseInfoApp.id}`, event.ctrlKey);
                        },
                    }),
                };
            }
        });

        if (overallFetchingState || overallErrorState) {
            this.props.setTabsView(false);
        } else {
            this.props.setTabsView(true);
        }

        var toolbarOptions = [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],

            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction

            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'font': [] }],
            [{ 'align': [] }],

            ['clean']                                         // remove formatting button
        ];

	    let editorButton, deleteButton;

        if (!(this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED)) {
            if (!this.state.infoEditable) {
                editorButton = <Button style={{display: 'inline-block', float: 'right', marginTop: '-10px'}}
                                       disabled= {!this.editCaseDetailPerm} onClick={this.toggleInfoEdit}>
                    <EditOutlined/>
                </Button>
            } else {
                editorButton = <Button style={{display: 'inline-block', float: 'right', marginTop: '-10px'}}
                                       onClick={this.updateCase}>
                    SAVE
                </Button>
            }
        }

        deleteButton = <Button style={{display: 'inline-block', float: 'right', marginTop: '-10px'}}
                               disabled={!this.deleteCasePerm} onClick={this.deleteCase}>
            <DeleteOutlined/>
        </Button>

        let infoComponent;

        if(!this.state.infoEditable){
            infoComponent =  <div><div className="heading-style sub-heading-style">
                <b className="case-scans-heading-style">Details</b>
	            {editorButton}
	            {deleteButton}
            </div>
                <div>
                    <br />
                    <Row>
                        <Col offset={1}>
                            {this.state.isFetchingCase ? getLoadingComponent() :
                                this.state.hasCaseThrownError ? getErrorComponent("Not able to retrieve the case details.") :
                                    <div>
                                        <Descriptions size="small" column={5}>
                                            <Descriptions.Item
                                                label={<b>{getCaseIdPlaceholder()}</b>}>{this.state.currCase.case_id}</Descriptions.Item>
                                            <Descriptions.Item label={<b>Patient's
                                                Name</b>}>{this.state.currCase.patient_name}</Descriptions.Item>
                                            <Descriptions.Item
                                                label={<b>DOB</b>}>{this.state.currCase.age_and_sex}</Descriptions.Item>
                                            <Descriptions.Item label={<b>Receiving
                                                Date</b>}>{this.state.currCase.receiving_date}</Descriptions.Item>
                                            <Descriptions.Item label={<b>Reporting
                                                Date</b>}>{this.state.currCase.reporting_date}</Descriptions.Item>
                                            <Descriptions.Item label={<b>Consulting
                                                Doctor</b>}>{this.state.currCase.consulting_doctor}</Descriptions.Item>
                                            <Descriptions.Item label={<b>Reg.
                                                Location</b>}>{this.state.currCase.registered_location}</Descriptions.Item>
                                            <Descriptions.Item label={
                                                <b>Priority</b>}>{this.state.currCase.priority}</Descriptions.Item>
                                            <Descriptions.Item label={null}>
                                                <Upload
                                                    style={{display: "flex"}}
                                                    action="/api/upload_trf/"
                                                    headers={{Authorization: AuthHeader()}}
                                                    maxCount={1}
                                                    data={{'case_id': this.state.currCase.case_id}}
                                                    fileList={this.state.currCase.trf_uploaded || this.state.trfFile ? [
                                                        Object.assign(this.state.trfFile || {uid: this.state.currCase.id}, {
                                                            name: `${this.state.currCase.case_id}_trf.pdf`,
                                                            url: "/case-files/" + this.state.currCase.case_id + "/case_trf/" + this.state.currCase.case_id + "_trf.pdf",
                                                        })
                                                    ] : []}
                                                    accept="image/*, .pdf"
                                                    beforeUpload={this.beforeUpload}
                                                    onChange={this.handleChangeUploadTRF}
                                                    onRemove={this.handleRemoveTrfFile}
                                                    disabled={this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED}
                                                >
                                                    <div>
                                                        <UploadOutlined/>
                                                        {this.state.currCase.trf_uploaded || this.state.trfFile ?
                                                            <b> Replace TRF: </b> :
                                                            <b> Upload TRF: </b>
                                                        }
                                                    </div>
                                                </Upload>
		                                    </Descriptions.Item>
	                                    </Descriptions>
                                    </div>
                            }
                        </Col>
                    </Row>
                    <br />
                </div></div>
        } else{
            infoComponent = <div>
                <div className="heading-style sub-heading-style">
                    <b className="case-scans-heading-style">Details</b>
                    {editorButton}
                </div>
                <div>
                    <br />
                    <Row>
                        <Col offset={1}>
                            {this.state.isFetchingCase ? getLoadingComponent() :
                                this.state.hasCaseThrownError ? getErrorComponent("Not able to retrieve the case details.") :
                                    <div>
                                        <Descriptions size="small" column={3}>
                                            <Descriptions.Item label={<b>{getCaseIdPlaceholder()}</b>}>
                                                <Input onChange={this.onChangeCaseId} value={this.state.case_id}>
                                                </Input>
                                            </Descriptions.Item>
                                            <Descriptions.Item label={<b>Patient's Name</b>}>
                                                <Input onChange={this.onChangePatientName}
                                                       value={this.state.patient_name}></Input>
                                            </Descriptions.Item>
                                            <Descriptions.Item label={<b>DOB / Age</b>}>
                                                <DatePicker onChange={this.onChangeDOB}
                                                        className="input-field-add-case"
                                                        allowClear={false}
                                                        style={{width:'175px'}}
                                                />
                                                <span style={{ paddingTop: "4px" }}>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                                                <InputNumber
                                                    min={0}
                                                    max={150}
                                                    className={"input-field-add-case"}
                                                    style={{ width: '48px' }}
                                                    onChange={this.onChangeAge}
                                                    placeholder={"Enter Age"}
                                                    value={this.state.age}
                                                />
                                            </Descriptions.Item>
                                            <Descriptions.Item label={<b>Gender</b>}>
                                                <Select className="input-field-add-case"
                                                        value={this.state.gender}
                                                        placeholder="Select Status"
                                                        onChange={this.onChangeGender}
                                                >
                                                    <Option value="M">Male</Option>
                                                    <Option value="F">Female</Option>
                                                    <Option value="Others">Others</Option>
                                                </Select>
                                            </Descriptions.Item>
                                            <Descriptions.Item label={<b>Receiving Date</b>}>
                                                <DatePicker onChange={this.onChangeReceivingDate}
                                                            value={new moment(this.state.receiving_date)}
                                                            className="input-field-add-case"
                                                            allowClear={false}
                                                />
                                            </Descriptions.Item>
                                            <Descriptions.Item label={<b>Reporting Date</b>}>
                                                <DatePicker
                                                    onChange = {this.onChangeReportingDate}
                                                    value={new moment(this.state.reporting_date
                                                    )}
                                                    className="input-field-add-case"
                                                    allowClear={false}
                                                />
                                            </Descriptions.Item>
                                            <Descriptions.Item label={<b>Consulting Doctor</b>}>
                                                <Input onChange={this.onChangeConsultingDoctor}
                                                       value={this.state.consulting_doctor}></Input>
                                            </Descriptions.Item>
                                            <Descriptions.Item label={<b>Reg. Location</b>}>
                                                <Select className="input-field-add-case"
                                                        value={this.state.registered_location}
                                                        placeholder="Select Registered Location"
                                                        onChange={this.handleRegisteredLocationChange}
                                                >
                                                    {this.getRegisteredLocationOptions()}
                                                </Select>
                                            </Descriptions.Item>
                                            <Descriptions.Item label={<b>Priority</b>}>
                                                <Select className="input-field-add-case"
                                                        value={this.state.priority}
                                                        placeholder="Select Priority"
                                                        onChange={this.onChangePriority}
                                                >
                                                    {this.props.allCasePriorities?.map((priority_obj) => {
                                                        return <Option value={priority_obj?.name}>{priority_obj?.name}</Option>
                                                    })}
                                                </Select>
                                            </Descriptions.Item>
                                        </Descriptions>
                                    </div>
                            }
                        </Col>
                    </Row>
	                <br/>
                </div>

            </div>
        }

	    let editOverrideButton;
        if (this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED) {
            editOverrideButton =
                <span style={{color: 'blue', position: 'absolute', right: '0'}}> The report has been locked.</span>
        } else if (this.state.can_edit) {
            editOverrideButton =
                <span style={{color: 'green', position: 'absolute', right: '0'}}> You are editing the report.</span>
        } else {
            editOverrideButton = <span style={{color: 'red', position: 'absolute', right: '0'}}>
                {`Can't edit as ${this.state.editing_user} is editing the report. To override access click     `}
                <Button onClick={this.getOverwriteAccess}>
                    OVERRIDE ACCESS
                </Button>
            </span>
	    }

	    let assign_comp = <div>
		    <Row style={{marginTop: '10px'}}>
			    {assigned_users_component}
		    </Row>
	    </div>;

        return (overallFetchingState) ?
            getLoadingComponent() :
            (overallErrorState) ?
                getErrorComponent() :
                <>
                    <div>

                        {infoComponent}

                        <div className="heading-style sub-heading-style">
                            <b className="case-scans-heading-style">Assigned Users To {getCaseNamePlaceholder()}</b>
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            {assign_comp}
                        </div>

                        <br/>

                        <div className="heading-style sub-heading-style">
                            <b className="case-scans-heading-style">Scans in {getCaseNamePlaceholder()}</b>
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                <Button onClick={this.toAllSlidesPage} disabled={!hasPermissions([aclPermissions.update_slides_in_case])}>
                                    Add Slides to {getCaseNamePlaceholder()}
                                </Button>
                        </div>
                        <div>
                            <br/>
                            <Row>
                                <Col>
                                    {this.state.isFetchingSlides ? getLoadingComponent() :
                                        this.state.hasSlidesThrownError ? getErrorComponent("Not able to retrieve slides of the case.") :
                                            <div>
                                                <Row key={0} className="fixed-controls-dashboard" id="fixed-controls-dashboard">
                                                    <Col span={24}>
                                                        {rowActions}
                                                        <Divider />
                                                    </Col>
                                                </Row>
                                                <Row key={1} className="scrollable-dashboard">
                                                    <Table
                                                        key={2}
                                                        loading={this.state.isFetching}
                                                        dataSource={tableSource}
                                                        columns={finalColumns}
                                                        pagination={false}
                                                        showHeader={false}
                                                        rowSelection={this.isMobile ? undefined : rowSelection}
                                                        onRow={onRow}
                                                        components={components}
                                                        scroll={{y: '550px'}}
                                                        className="custom-table-height custom-table-selection"
                                                        rowClassName={record => (record.unread ?
                                                            'slide-table-rows custom-hover-table-box editable-row unread'
                                                            : 'slide-table-rows custom-hover-table-box editable-row read')}
                                                    />
                                                </Row>
                                            </div>
                                    }
                                </Col>
                            </Row>
	                        <br/>
                        </div>
                        {this.viewCapReportPerm ?
                            <div>
                                <div className="heading-style sub-heading-style">
                                    <b className="case-scans-heading-style"> Report</b>
                                </div>
                                <br/>
                                <div>
                                    Biomarker Reporting Protocol &#160;
                                    <Select showSearch placeholder={this.state.selectedCAP} style={{width: 200}}
                                            onChange={this.handleCAPTemplateChange}
                                            disabled={!this.state.can_edit ||
                                                (this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED) ||
                                                !hasPermissions([aclPermissions.update_cap_report])
                                            }>
                                        {cap_report_name_options}
                                    </Select>
                                    {editOverrideButton}
                                    <br/>
                                    <br/>
                                    <div>
                                        <span
                                            style={{
                                                color: this.state.save_status['color'],
                                                'font-size': '14px',
                                                'font-weight': 700
                                            }}>
                                            {this.state.save_status['use_loader'] &&
                                                <><SpinLoader fontSize={18}/> &nbsp;</>}

                                            {this.state.save_status['message_cap_report']}
                                        </span>
                                    </div>
                                    <Row>
                                        <Col>
                                            <Suspense fallback={<div>Loading...</div>}>
                                                <ReactQuill
                                                    readOnly={!hasPermissions([aclPermissions.update_cap_report]) || (this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED)}
                                                    modules={{
                                                        // syntax: true,
                                                        toolbar: toolbarOptions
                                                    }}
                                                    theme="snow"
                                                    style={{height: "450px"}}
                                                    formats={[
                                                        'header',
                                                        'bold', 'italic', 'underline', 'strike', 'blockquote',
                                                        'list', 'bullet', 'indent',
                                                        'link', 'image',
                                                        'code-block'
                                                    ]}
                                                    value={this.state.CAPContent}
                                                    onChange={this.onChangeCAPContent}
                                                >
                                                </ReactQuill>
                                            </Suspense>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <br/>
                                    <br/>
                                    <br/></div>
                            </div>
                            : null}
                        <Divider style={{backgroundColor: "#ffffff00"}}/>
                        <CaseSuggestions modalVisible={this.state.assignCaseModalVisible} selectedSlide={this.state.selectedSlide}
                                         closeModal={this.closeModal} />
                        <SlideSuggestions modalVisible={this.state.addSlideModalVisible} currCase={this.state.currCase}
                                          closeModal={this.closeModal}/>
                        <Modal visible={this.state.screenshotVisible} footer={null}
                               onCancel={this.handleScreenshotCancel} width={1500}>
                            {getScreenshotCarousel(this.state.screenshots)}
                        </Modal>
                    </div>
                    <div className="heading-style sub-heading-style">
                        <b className="case-scans-heading-style">Scan Screenshots</b>
                    </div>
                    <FileScreenshotsList files={this.state.screenshots}
                                         showOnHover={true}
                                         disabled={this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED}
                                         cols={8} onClick={file =>
                        openEndPoint(`/gamma/${file.slide}?${convertMapStateToUrlParams(
                            {id: file.slide, ...file.meta.mapState})}`, true)}
                                         onDelete={this.handleDeleteScreenshot}
                    />
                    <div className="heading-style sub-heading-style">
                        <b className="case-scans-heading-style">Other Files</b>
                    </div>
                    <div>
                        <br/>
                        <Row>
                            <Col>
                                {this.state.isFetchingFiles ? getLoadingComponent() :
                                    this.state.hasFilesThrownError ? getErrorComponent("Not able to contact server. Please contact admin.") :
                                        <div>
                                            <Upload
                                                listType="picture"
                                                action={getStateAwareUrl("/api/files/")}
                                                headers={{Authorization: AuthHeader()}}
                                                fileList={this.state.caseFileList}
                                                data={{'case': this.state.currCase.id}}
                                                onPreview={this.handlePreview}
                                                onChange={this.handleChangeCaseFile}
                                                onRemove={deleteFile}
                                                showUploadList={{
                                                    showDownloadIcon: true,
                                                    downloadIcon: <ToTopOutlined/>,
                                                }}
                                                className='upload-list-inline'
                                                accept="image/*, .pdf"
                                                beforeUpload={this.beforeUpload}
                                                disabled={this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED}
		                                    >
			                                    <div style={{textAlign: 'center'}}>
                                                    <Button
                                                        disabled={this.lockCapReport && this.state.currCase['case_status'] === CASE_STATUS.REPORT_GENERATED}>
                                                        <UploadOutlined/> Upload Supporting Files
                                                    </Button>
			                                    </div>
		                                    </Upload>
		                                    <Modal visible={this.state.previewVisible} footer={null}
		                                           onCancel={this.handleCancel}>
                                                {this.state.showFile ?
                                                    <Carousel height={200} index={this.state.carousel_index}
                                                              swipe={true} indicators={true} cycleNavigation={false}
                                                              autoPlay={false} navButtonsAlwaysVisible={true}>
                                                        {this.state.caseFileList.map(file =>
                                                            <img src={file.url} alt={file.name} width={450}
                                                                 height={200}
                                                                 style={{padding: 1}}/>)
                                                        }
                                                    </Carousel>
                                                    : <div>No preview available</div>
                                                }
                                            </Modal>
                                            {
                                                this.state.caseFileList.length > 0 ?
                                                    null :
                                                    <div>
                                                        <Empty description="No Files Found" />
                                                    </div>
                                            }
                                        </div>
                                }
                            </Col>
                        </Row>
                        <br />
                    </div>
                    <Stack direction={"row"} spacing={1}>
                            {isTrue(this.archivalLogicHandler()[0]) ?
                                <Button type="secondary" style={{ cursor: 'pointer' }} onClick={() => this.handleCaseReport(true, false, this.archivalLogicHandler()[1])}>
                                Mark Unreported
                            </Button> :
                                <Button type="primary" style={{ cursor: 'pointer' }} onClick={() => this.handleCaseReport(false, false, this.archivalLogicHandler()[1])}>
                                    Mark as Reported
                                </Button>}
                        {!isTrue(this.archivalLogicHandler()[0]) ? <Button type="primary" style={{ cursor: 'pointer' }}
                                                                                           onClick={() => this.handleCaseReport(true, true, this.archivalLogicHandler()[1])}>
                                Mark as Reported And Archive
                            </Button> : null}
                        <ThemeProvider theme={defaultTheme}>

                            <MuiButton
                                color="primary"
                                size="small"
                                variant="outlined"
                                disabled={!hasPermissions([aclPermissions.generate_report])}
                                style={{cursor: 'pointer'}}
                                onClick={() => this.generateReport()}
                            >
                                Generate Report
                            </MuiButton>
                        </ThemeProvider>

                    </Stack>

                    <Divider style={{ backgroundColor: "#ffffff00" }} />
                    <SlideDetailsModal modalVisible={this.state.slideDetailsModelVisible} selectedSlide={this.state.selectedSlide} closeModal={this.closeModal} />
                    {this.props.caseModalOpen ? <ShareModal type={openInNewTabType.CASE} assign={true} case_id={this.state.currCase.case_id}
                                                            caseRefreshProps={this.caseRefreshProps} getFullCaseData={true}/> : null}
                </>
    }
}

const mapStateToProps = (state) => {
    let {abstract_configs} = state.morpheusSettingReducer;
    return {
        allSlides: state.slidesReducer,
        numPages: state.dashboardReducer.numPages,
        urlState: state.searchReducer,
        height: state.contextMenuReducer.popupProps.height,
        allUsers: state.caseStatusReducer.users,
        allCaseStatus: state.caseStatusReducer.case_status,
        allCasePriorities: state.caseStatusReducer.case_priority,
        caseModalOpen: state.shareManagerReducer.caseModalOpen,
        sorting: state.morpheusSettingReducer.sorting?.slide_in_case_order_by,
        abstract_configs
    }
}

export default connect(mapStateToProps)(AllScansCaseView);